import React, { useState } from 'react'
import Dropdown from '../../../components/Dropdown'
import GenericModal from '../../../components/GenericModal'
import CreateAndEditCourseCatalog from '../CreateNewCourseCatalog'
import { useAppDispatch } from '../../../store'
import { getDivisionCoursesApi } from '../../../store/slices/courseCatalogSlice/api'
import { type ApplyFiltersAndDispatchParams } from '../../../components/CustomTable/types'
import CsvMappingUpload from '../../../components/CsvMappingUpload'
import { notification } from '../../../components/Notifications'

interface CoursesCatalogTopbarActionsProps {
  params?: ApplyFiltersAndDispatchParams
}

const CoursesCatalogTopbarActions: React.FC<CoursesCatalogTopbarActionsProps> = ({ params }) => {
  const [isUploadModal, setIsUploadModal] = useState<boolean>(false)
  const [isCreateModal, setIsCreateModal] = useState<boolean>(false)
  const dispatch = useAppDispatch()

  const closeUploadModal = (): void => {
    setIsUploadModal(false)
  }

  const uploadApi = (): void => {
    setIsUploadModal(true)
  }

  const addManually = (): void => {
    setIsCreateModal(true)
  }

  const menuItems = [
    { text: 'Upload Courses (.csv)', action: uploadApi },
    { text: 'Add Manually', action: addManually }
  ]

  return (
    <>
      <Dropdown menuItems={menuItems} label='Add Courses'/>
      <GenericModal
        isOpen={isCreateModal}
        title={'Create Course '}
        onClose={() => { setIsCreateModal(false) }}
        maxWidth='sm'
        action={false}
      >
        <CreateAndEditCourseCatalog handleCloseModal={() => { setIsCreateModal(false) }} params={params} />
      </GenericModal>

      <CsvMappingUpload csvHeaderEndpoint="/api/divisions/csv_headers" isOpen={isUploadModal} modalTitle="Courses" onClose={closeUploadModal} uploadCsvEndpoint="/api/divisions/" onSuccess={() => {
        notification('Courses successfully uploaded', { variant: 'success' })
        void dispatch(getDivisionCoursesApi({ params }))
      }}/>
    </>
  )
}

export default CoursesCatalogTopbarActions
